@if (visible() && (text() || icon())) {
<div #tooltipElement
     class="hover-tooltip"
     [class.hover-tooltip--below]="verticalSide() === 'below'"
     [ngStyle]="resolvedStyle()">
  <div class="tooltip-content">
    @if (text()) {
    <span class="tooltip-text b">{{ text() }}</span>
    }
    @if (icon()) {
    <button type="button" class="tooltip-icon-btn" (click)="onIconClick($event)" 
            [attr.aria-label]="'hoverComponent.additionalInfo' | t">
      <img class="icon icon-20 icon-gray-100" [src]="icon()" alt="Info">
    </button>
    }
  </div>
</div>
}
